import { ModalType } from "../../Enums/ModalType";
import { open, close, selectModal, ModalState } from "../Slices/ModalSlice";
import { useDispatch, useSelector } from "react-redux";

// Hooks used to open/close modals from outside components
export const useModalHooks = () => {
  const dispatch = useDispatch();
  const modalStatus = useSelector(selectModal);

  const isModalTypeOpen = (type: ModalType) => {
    if (type === modalStatus.type) {
      return modalStatus.open;
    } else {
      return false;
    }
  };

  const openModal = (modal?: ModalState) => {
    if (modal) {
      dispatch(open(modal));
    } else {
      dispatch(open({ open: true, type: ModalType.General }));
    }
  };

  const closeModal = () => {
    dispatch(close());
  };

  return {
    modalStatus,
    openModal,
    closeModal,
    isModalTypeOpen,
  } as const;
};
